import { apiClient } from './apiClient';

export const createOwner = async (payload) => {
  return await apiClient('/admin/management/owners', {
    method: 'POST',
    body: JSON.stringify(payload),
  }, true);
};